import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Tooltip,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Menu
} from "@material-ui/core";
import {
  AddIconTwo,
  DeleteIcon,
  EditIconTwo,
  CopyIcon2,
  ViewIcon,
  ReportHistoryIcon2,
  DeviceIcon2,
  ReferenceImgIcon
} from '../../components/Icons';
import { useHistory } from "react-router-dom";
import { ToasterComponent } from "../maintenance/test-automation/components/Toaster";
import { makeStyles } from "@material-ui/core/styles";
import { environment } from "../../environments/environment";
import { SearchBar } from "../../components/sub-components/SearchBar";
import React, { useState, useEffect, useMemo } from "react";
import useStyles from "../../app/maintenance/assets/styles";
import { Pagination } from "@material-ui/lab";
import { CloseIconColor } from "../../components/Icons";
import { AuthService } from '../../app/authentication/auth.service'
import { Kit, KitModel, Device } from "../models";
import axios from 'axios';
import { MappedKitModel } from "../setup-senzmatica/step-3/steps/MappedKitModel";
import Cookies from "js-cookie";
import { FilterList } from "@material-ui/icons";
import { getAllDevices } from "../testing-automation/api-helper/apiHelper";

export function KitComponent() {
  const classes = localStyles();
  const style = useStyles();
  const history = useHistory();

  const [kitModels, setKitModels] = useState<KitModel[]>([]);
  const [devices, setDevices] = useState<Device[]>([]);
  const [allKits, setAllKits] = useState<Kit[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedKit, setSelectedKit] = useState<Kit>(null);
  const [selectedKitDelete, setSelectedKitDelete] = useState<Kit>(null);
  const [isCloning, setIsCloning] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [error, setError] = useState(null);
  const [allSensors, setAllSensors] = useState([]);
  const [allActuators, setAllActuators] = useState([]);
  const [allTypes, setAllTypes] = useState([]);
  const [isToasterOpen, setIsToasterOpen] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [reqSuccess, setReqSuccess] = useState(false);
  const [lastCreatedKit, setLastCreatedKit] = useState("");
  const [filterBtnEnable, setFilterBtnEnable] = useState(false);
  const [selectedValidity, setSelectedValidity] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);
  const [lastCreatedKitModel, setLastCreatedKitModel] = useState("")
  const [formType, setFormType] = useState("Add");
  const [kitModelFormType, setKitModelFormType] = useState("Edit");
  const [referenceImgLoaded, setReferenceImgLoaded] = useState(false);
  const [refImageModal, setRefImageModal] = useState(false);
  const [status, setStatus] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  const [isExistKitModel, setIsExistKitModel] = useState(false);
  const [isSelectStep3, setIsSelectStep3] = useState(false);
  const [isApiClick, setIsApiClick] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const statusList = ['All', 'Approved', 'Submitted', 'Rejected'];
  const [statusCount, setStatusCount] = useState(
    {
      APPROVED: 0,
      SUBMITTED: 0,
      REJECTED: 0,
    }
  );

  const initialDataFetch = async () => {
    setLoadingScreen(true);
    try {
      await Promise.all([
        getKits(),
        getKitModels(),
        getDevices(),
        getMetaData(),
        fetchAllKitTypes()
      ]);
    } catch (error) {
      console.error("Error in initial data fetch:", error);
    } finally {
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    initialDataFetch();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  const fetchImagesForKit = async (kit) => {
    setLoadingScreen(true);
    try {
      const response = await fetch(`${environment.host}/user/${Cookies.get("USER_ID")}/kit/${kit.id}/referenceImage`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setImages(data.content.referenceImages || []);

    } catch (error) {
      console.error('Error fetching images:', error);
    } finally {
      setLoadingScreen(false);
    }
  }

  const fetchAllKitTypes = async () => {
    try {
      const response = await fetch(`${environment.host}/core/kitType`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const types = data.content;

      setAllTypes(types);

    } catch (error) {
      console.error('Error fetching metadata:', error);
    }
  };

  const getKits = async () => {
    try {
      const response = await fetch(`${environment.host}/core/kit?returnType=DETAIL`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`
        }
      });
      if (!response.ok) throw new Error('Failed to fetch kit models');

      const data = await response.json();
      setAllKits(data.content);

      const counts = data.content.reduce((acc, kit) => {
        acc[kit.submissionStatus] = (acc[kit.submissionStatus] || 0) + 1;
        return acc;
      }, { APPROVED: 0, SUBMITTED: 0, REJECTED: 0 });

      setStatusCount(counts);

      setReferenceImgLoaded(true);

    } catch (error) {
      console.error('Error fetching allKits:', error);
    }
  };

  const getKitModels = async () => {
    try {
      const response = await fetch(`${environment.host}/core/kit-model?returnType=FULL`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`
        }
      });
      if (!response.ok) throw new Error('Failed to fetch kit models');
      const data = await response.json();
      setKitModels(data.content);

    } catch (error) {
      console.error('Error fetching kit models:', error);
    }
  };

  const getDevices = async () => {
    try {
      const data = await getAllDevices('LIST');
      setDevices(data || []);
    } catch (error) {
      console.error('Error fetching devices:', error);
    }
  };

  const isActuatorViewDisabled = (kit) => {
    console.log(kit)
    const deviceId = kit.devices[0];
    const device = devices.find(d => d.id === deviceId);
    return (
      !device ||
      !Array.isArray(device.actuatorCodes) ||
      device.actuatorCodes.length === 0
    );
  };

  const getMetaData = () => {
    return new Promise<void>((resolve, reject) => {
      axios.get(`${environment.host}/core/meta-data`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`
        }
      })
        .then((response) => {
          const sensors = response.data.content.sensors.sort((a, b) => {
            return a.name < b.name ? -1 : 1;
          })
          const actuators = response.data.content.actuators.sort((a, b) => {
            return a.name < b.name ? -1 : 1;
          })
          const types = response.data.content.kitTypes;
          setAllSensors(sensors)
          setAllActuators(actuators)
          resolve();
        })
        .catch((error) => {
          console.error('Error fetching metaData:', error);
          reject(error);
        });
    })
  }

  const isMlEngineer = () => {
    return AuthService.isMlEngineer()
  }

  function toggleHideById(id: string): void {
    const element = document.getElementById(id);
    if (element) {
      element.classList.toggle('hide');
    }
  }

  const updateValidity = (validity) => {
    setSelectedValidity(validity === 'All' ? null : validity);
    handleFilterClose()
  };

  const updateStatus = (status) => {
    setSelectedStatus(status);
    setFilterBtnEnable(true);
  };

  const referenceOpen = (kit) => {
    setSelectedKit(kit);
    setRefImageModal(true);
    fetchImagesForKit(kit);
  };

  const closePopup = () => {
    setRefImageModal(false);
    setSelectedKit(null);
  }

  const updateImgStatus = async () => {
    setLoadingScreen(true);
    try {
      const response = await fetch(
        `${environment.host}/user/${Cookies.get("USER_ID")}/kit/${selectedKit.id}/referenceImageStatus?status=${status}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to update reference image status");
      const data = await response.json();
      setKitModels(data.content);
      setStatusCount(prevStatusCount => ({
        ...prevStatusCount,
        [status]: (prevStatusCount[status] || 0) + 1,
        [selectedKit.submissionStatus.toUpperCase()]: (prevStatusCount[selectedKit.submissionStatus.toUpperCase()] || 0) - 1
      }));
      setAllKits(prevKits =>
        prevKits.map(kit =>
          kit.id === selectedKit.id ? { ...kit, submissionStatus: status } : kit
        )
      );
    } catch (error) {
      console.error("Error updating reference image status:", error);
    } finally {
      setLoadingScreen(false);
    }
  }

  const historyPush = (path: string) => {
    window.location.href = path;
  

  };

  const hideForm = () => {
    console.log("hide form")
  }

  const kitValidity = (kit: Kit): boolean => {
    const kitModel = kitModelMap.get(kit.model.id);
    if (!kitModel) return false;

    const currentDevices: Device[] = kit.devices
      .map(id => deviceMap.get(id))
      .filter(Boolean) as Device[];

    const deviceActuatorCodes = currentDevices.map(dev => dev.actuatorCodes).reduce((a, b) => a.concat(b), []);
    const deviceSensorCodes = currentDevices.map(dev => dev.sensorCodes).reduce((a, b) => a.concat(b), []);

    const kitModelActuators = kitModel.actuators || [];
    const kitModelSensors = kitModel.sensors || [];

    const actuatorsMatch = deviceActuatorCodes.every(code => kitModelActuators.includes(code));
    const sensorsMatch = deviceSensorCodes.every(code => kitModelSensors.includes(code));

    return (
      kitModelActuators.length === deviceActuatorCodes.length &&
      kitModelSensors.length === deviceSensorCodes.length &&
      actuatorsMatch &&
      sensorsMatch
    );
  };

  const kitModelMap = useMemo(() => {
    const map = new Map();
    kitModels.forEach(model => map.set(model.id, model));
    return map;
  }, [kitModels]);

  const deviceMap = useMemo(() => {
    const map = new Map();
    devices.forEach(device => map.set(device.id, device));
    return map;
  }, [devices]);

  const filteredKits = useMemo(() => {
    if (!allKits || allKits.length === 0) return [];

    console.log("allKits", allKits)

    const isEngineer = isMlEngineer();
    const search = searchTerm.trim().toLowerCase();

    const isDefaultFilter = 
      (!isEngineer && selectedValidity === 'All' && search === "") ||
      (isEngineer && selectedStatus === 'All' && search === "");

    if (isDefaultFilter) return allKits;

    return allKits.filter((kit: Kit) => {
      const matchSearch = search === "" || JSON.stringify(Object.values(kit)).toLowerCase().includes(search);
      if (!matchSearch) return false;

      if (isEngineer) {
        const status = kit.submissionStatus.toUpperCase() || "NAN";
        return selectedStatus === "All" || status === selectedStatus.toUpperCase();
      } else {
        if (selectedValidity === "Valid" && !kitValidity(kit)) return false;
        if (selectedValidity === "Invalid" && kitValidity(kit)) return false;
        return true;
      }
    });
  }, [allKits, kitModels, devices, searchTerm, selectedValidity, selectedStatus]);

  const increaseStep = () => {
    console.log("this is increase step");
    setShowForm(false);
  }

  const setIsEyeIconClick = () => {
    console.log("this is edit popup cancel");
    setShowForm(false);
  }

  const assignKit = (selectKit) => {
    let kit
    if (selectKit == "") {
      console.log(lastCreatedKit)
      kit = allKits.filter(kit => kit.name.toLowerCase() == lastCreatedKit.toLowerCase())

    } else {
      console.log(selectKit)
      kit = allKits.filter(kit => kit.name.toLowerCase() == selectKit.name.toLowerCase())
    }

    return kit;
  }

  const editKit = (kit: any) => {
    setFormType("Update");
    setKitModelFormType("Update");
    setSelectedKit(assignKit(kit));
    setShowForm(true);
  };

  const cloneKit = (kit: any) => {
    setIsCloning(true);
    setFormType("Clone");
    setKitModelFormType("Clone");
    setSelectedKit(assignKit(kit));
    setShowForm(true);
  };

  const addKit = () => {
    setFormType("Add");
    setKitModelFormType("Add");
    setShowForm(true);
    setSelectedKit(null);
  };

  const handleSubmitKit = (kit: any) => {
    console.log("creating kit: ", kit);
    setLoadingScreen(true);
    let user = Cookies.get("USER_ID");
    const requestMethod = formType === "Update" ? "put" : "post";
    const requestUrl =
      formType === "Update"
        ? `${environment.host}/core/user/${user}/kit/${kit.id}`
        : `${environment.host}/core/user/${user}/kit-model/${kit.kitModelId}/kit`;

    axios[requestMethod](requestUrl, kit, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        console.log(response.data.content);
        if (response.data.message === "Success") {
          setIsToasterOpen(true);
          setToasterMessage("Kit " + formType + "ed Successfully");
          setReqSuccess(true);
          setLastCreatedKit(response.data.content.name);
          setShowForm(false);
          initialDataFetch();
          setIsCloning(false);
        } else {
          setIsToasterOpen(true);
          console.error("Failed to create kit model:", response.data.message);
        }
      })
      .catch((error) => {
        setIsToasterOpen(true);
        setReqSuccess(false);
        setToasterMessage(error.response.data.message);
        console.error("Error creating kit model:", error);
      })
      .finally(() => {
        setTimeout(() => {
          setIsToasterOpen(false);
          setLoadingScreen(false);
        }, 4000);
      });
  };

  const deleteKit = async () => {
    if (!selectedKitDelete) return;

    setLoadingScreen(true);
    try {
      const response = await fetch(`${environment.host}/core/kit/${selectedKitDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to delete kit: ${response.statusText}`);
      }
      setIsToasterOpen(true);
      setToasterMessage("Kit Deleted Successfully");
      setReqSuccess(true);

      setAllKits((prevKits) => prevKits.filter((kit) => kit !== selectedKitDelete));
      setSelectedKitDelete(null);
    } catch (error) {
      console.error('Error deleting kit:', error);
      setIsToasterOpen(true);
      setToasterMessage("Error while Delete Kit");
      setReqSuccess(false);
    } finally {
      setLoadingScreen(false);
      setTimeout(() => {
        setIsToasterOpen(false);
      }, 4000);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrentPage(newPage); // Ensure both variables are updated
  };
  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
    setSelectedKit({ ...selectedKit, submissionStatus: event.target.value })
  }

  const handleFilter = () =>{
    if(filterBtnEnable){
      console.log(filterBtnEnable)
      setFilterBtnEnable(false)
    }else{
      console.log('filterBtn',filterBtnEnable)
      setFilterBtnEnable(true)
    }
  }

  const handleFilterClick = (event) => {setAnchorEl(event.currentTarget)};
  const handleFilterClose = () => {setAnchorEl(null)};

  return (
    <div className={classes.root}>
      <div className="page-heading">
        Kit Board
      </div>
      <div className={`testing`}>
        <Grid container className={style.container}>
          <Grid container alignItems="center">
            <Grid style={{ textAlign: "left", width: "255px", margin: " 0 10px 0 0" }}>
              <SearchBar placeholder="Search Kit" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </Grid>

            <Grid item>
              <div className="filerButton" onClick={handleFilterClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ padding: "4px" }}
                >
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                </svg>
                {isMlEngineer() ? "Status" : "Filter"}
              </div>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleFilterClose} style={{ top: '48px' }}>
                {(isMlEngineer() ? statusList : ["All", "Valid", "Invalid"]).map((option) => (
                  <MenuItem key={option} onClick={() => isMlEngineer() ? updateStatus(option) : updateValidity(option)}>
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </Grid>

            {isMlEngineer() && (
              <Grid item style={{ marginLeft: "auto" }}>
                <div className={classes.statusListStyle}>
                  <span className={classes.approvedStyle}>{"Approved (" + statusCount.APPROVED + ")"}</span>
                  <span className={classes.pendingStyle}>{"Submitted (" + statusCount.SUBMITTED + ")"}</span>
                  <span className={classes.notApprovedStyle}>{"Rejected (" + statusCount.REJECTED + ")"}</span>
                </div>
              </Grid>
            )}
          </Grid>
          <Grid item xs={12} md={12} style={{ marginTop: "20px" }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableCell}>ID</TableCell>
                    <TableCell className={classes.tableCell}>Kit Name</TableCell>
                    {!isMlEngineer() ? (
                      <>
                        <TableCell className={classes.tableCell}>Devices</TableCell>
                        <TableCell className={classes.tableCell}>Reference</TableCell>
                        <TableCell className={classes.tableCell}>Validity</TableCell>
                        <TableCell className={classes.tableCell} style={{ textAlign: "center" }}>Interval</TableCell>
                        <TableCell className={classes.tableCell}>Persistence</TableCell>
                        <TableCell className={classes.tableCell} style={{ textAlign: "center" }}>Action</TableCell>
                      </>
                    ) : (
                      <>
                        <TableCell className={classes.tableCell}>Status</TableCell>
                        <TableCell className={classes.tableCell} style={{ textAlign: "center" }}>Display Image</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredKits
                    .slice((page - 1) * rowsPerPage, page * rowsPerPage)
                    .map((kit, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#F5F5F5" : "white",
                        }}
                      >
                        <TableCell className={classes.tableCellBody}>{kit.id}</TableCell>
                        <TableCell className={classes.tableCellBody}>{kit.name}</TableCell>
                        {!isMlEngineer() ? (
                          <>
                            <TableCell className={classes.tableCellBody}>
                              {kit.devices.map((dev, i) => (
                                <span
                                  key={i}
                                  style={{ cursor: "pointer" }}
                                // onClick={() => navigate(`/device/${kit.devices[i]}`)} // Use navigate instead of history.push
                                >
                                  {dev}&nbsp;
                                </span>
                              ))}
                            </TableCell>
                            <Tooltip title={kit.referenceName}>
                              <TableCell className={classes.tableCellBody}>{kit.referenceName.length > 20 ? kit.referenceName.slice(0, 20) + "...": kit.referenceName}</TableCell>
                            </Tooltip>
                            <TableCell className={classes.tableCellBody}>
                              <label className={`${classes.validityLabel} ${kitValidity(kit) ? classes.valid : classes.invalid}`}>
                                {kitValidity(kit) ? 'Valid' : 'Invalid'}
                              </label>
                            </TableCell>
                            <TableCell className={classes.tableCellBody} style={{ textAlign: "center" }}>{kit.interval}</TableCell>
                            <TableCell className={classes.tableCellBody}>{kit.persistence ? "True" : "False"}</TableCell>
                            <TableCell
                              className={classes.tableCellBody}
                              style={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Tooltip
                                title={kit.model.noOfProperties === 0 ? "No data available" : "View"}
                              >
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ padding: "4px" }}
                                    disabled={kit.model.noOfProperties === 0}
                                    onClick={() => historyPush(`/kit-view/${kit.id}`)}
                                  >
                                    <ViewIcon color={kit.model.noOfProperties === 0 ? "#B0B0B0" : "#707070"}  />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip
                                title={
                                  kit.actions.length === 0
                                    ? "No data available"
                                    : "Actuator View"
                                }
                              >
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ padding: "4px" }}
                                    disabled={kit.actions.length === 0}
                                    onClick={() => historyPush(`/device/${kit.devices[0]}/actuator`)}
                                  >
                                    <DeviceIcon2 color={kit.actions.length === 0 ? "#B0B0B0" : "#707070"} />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Edit">
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ padding: "4px" }}
                                    onClick={() => editKit(kit)}
                                  >
                                    <EditIconTwo />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Clone Kit">
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ padding: "4px" }}
                                    onClick={() => {
                                      setIsCloning(true);
                                      cloneKit(kit);
                                    }}
                                  >
                                    <CopyIcon2 />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Offline History">
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ padding: "4px" }}
                                    onClick={() => historyPush(`/kit/${kit.id}`)}
                                  >
                                    <ReportHistoryIcon2 />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ padding: "4px" }}
                                    onClick={() => {
                                      setSelectedKitDelete(kit);
                                      toggleHideById("deleteModal");
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell className={classes.tableCellBody}>
                              <label>
                                {kit.submissionStatus ? kit.submissionStatus : 'NaN'}
                              </label>
                            </TableCell>
                            <TableCell className={classes.tableCellBody}
                              style={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Tooltip title="Display Image">
                                <span>
                                  <IconButton
                                    size="small"
                                    style={{ padding: "4px" }}
                                    disabled={kit.submissionStatus ? false : true}
                                    onClick={() => referenceOpen(kit)}
                                  >
                                    <ReferenceImgIcon color={kit.submissionStatus ? "#707070" : "#a0a0a0"} />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Pagination */}
          <Grid container justifyContent="center">
            {filteredKits.length > rowsPerPage && (
              <Pagination
                className={style.pagination}
                page={page}
                onChange={handleChangePage}
                count={Math.ceil(filteredKits.length / rowsPerPage)}
                shape="rounded"
                defaultPage={1}
              />
            )}
          </Grid>
        </Grid>
      </div>
      {/* Floating Add Button */}
      {!isMlEngineer() && (
        <div
          className="material-button-div"
          style={{ position: "fixed", bottom: 20, right: 20 }}
        >
          <Button
            variant="contained"
            onClick={addKit}
            style={{
              minWidth: "50px",
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: "#2A7CED",
              color: "#fff",
              boxShadow: "0 3px 6px rgba(0,0,0,0.275)",
            }}
          >
            <AddIconTwo color="#FFF" />
          </Button>
        </div>
      )}


      {/* Loading Screen */}
      {loadingScreen && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            backgroundColor: "#000000",
            opacity: 0.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            width: "100vw",
            height: "100vh",
          }}
        >
          <CircularProgress size={80} />
        </div>
      )}

      <ToasterComponent
        reqSuccess={reqSuccess}
        message={toasterMessage}
        toaster={isToasterOpen}
      />

      {showForm && !isMlEngineer() && (
        <Dialog open={true}>
          <Grid container>
            <Grid item xs={10}>
              <DialogTitle>
                {formType === "Add" ? "Add New" : formType} Kit
              </DialogTitle>
            </Grid>
            <Grid item xs={2} style={{ textAlign: "right" }}>
              <IconButton onClick={() => setShowForm(false)}>
                <CloseIconColor />
              </IconButton>
            </Grid>
          </Grid>
          <Divider />
          <DialogContent style={{ padding: "8px 0px" }}>
            <MappedKitModel
              increaseStep={increaseStep}
              setKitModelFormType={setKitModelFormType}
              kitModelFormType={kitModelFormType}
              allSensors={allSensors}
              allActuators={allActuators}
              allTypes={allTypes}
              allKits={allKits}
              selectedKit={selectedKit}
              setLoading={setLoadingScreen}
              setIsToasterOpen={setIsToasterOpen}
              setToasterMessage={setToasterMessage}
              setReqSuccess={setReqSuccess}
              getKits={getKits}
              allDevices={devices}
              allKitModels={kitModels}
              setLastCreatedKit={setLastCreatedKit}
              formType={formType}
              selectKit={selectedKit}
              getKitTrigger={() => { }}
              hideFormTrigger={hideForm}
              isCloning={isCloning}
              getKitModels={getKitModels}
              getKitTypes={fetchAllKitTypes}
              setLastCreatedKitModel={setLastCreatedKitModel}
              setIsExistKitModel={setIsExistKitModel}
              handleSubmitKit={handleSubmitKit}
              setIsSelectStep3={setIsSelectStep3}
              setIsApiClick={setIsApiClick}
              setShowForm={setShowForm}
            />
          </DialogContent>
        </Dialog>
      )}

      {selectedKitDelete && (
        <Dialog open={true} onClose={() => setSelectedKitDelete(null)}
          maxWidth="md" classes={{ paper: style.deletePopup }}>
          <Grid container className={style.deleteHeader}>
            <Grid item xs={10} md={10} >
              <DialogTitle>CONFIRMATION</DialogTitle>
            </Grid>
            <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
              <IconButton onClick={() => setSelectedKitDelete(null)} style={{ paddingTop: "20px" }}>
                <CloseIconColor />
              </IconButton>
            </Grid>
          </Grid>
          <DialogContent className={style.deleteContent}>
            <Grid container>
              <Grid style={{ margin: "0" }}>
                <Typography className={style.popupLabel} style={{ color: "#FF4343" }}>
                  Are you sure you want to delete this kit {selectedKitDelete.name}?
                </Typography>
                <Typography className={style.popupLabel}>
                  The delete action will remove the kit
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <div className={style.DeletePopupFooter}>
            <Button
              variant="contained"
              onClick={() => setSelectedKitDelete(null)}
              className={style.popupCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              className={style.popupDelete}
              onClick={deleteKit}
              style={{ marginRight: "21px" }}
            >
              DELETE
            </Button>
          </div>
        </Dialog>
      )}

      {refImageModal && !isImagePopupOpen && (
        <Dialog open={true} onClose={() => setRefImageModal(false)} maxWidth="md">
          <div className={classes.modal}>
            <div className={classes.modalContent}>
              <Grid container>
                <Grid item xs={10}>
                  <DialogTitle>Reference Images</DialogTitle>
                </Grid>
                <Grid item xs={2} style={{ textAlign: "right" }}>
                  <IconButton onClick={() => setRefImageModal(false)}>
                    <CloseIconColor />
                  </IconButton>
                </Grid>
              </Grid>
              <DialogContent>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select value={selectedKit.submissionStatus} onChange={(e) => handleChangeStatus(e)} fullWidth>
                    <MenuItem value="SUBMITTED">Submitted</MenuItem>
                    <MenuItem value="APPROVED">Approved</MenuItem>
                    <MenuItem value="REJECTED">Rejected</MenuItem>
                  </Select>
                </FormControl>
                <div className={classes.imageBoxes}>
                  {images.map((image, i) => (
                    <div key={i} className={classes.imageBox}>
                      <img src={image} alt={`Reference Image ${i + 1}`}
                        className={classes.image}
                        loading="lazy"
                        onClick={() => {
                          setSelectedImage(image);
                          setIsImagePopupOpen(true);
                        }}
                      />
                      <p className={classes.imgText}>IMAGE {i + 1}</p>
                    </div>
                  ))}
                </div>
              </DialogContent>
              <Grid item xs={12}>
                <DialogActions>
                  <Button variant="contained" onClick={closePopup}>Cancel</Button>
                  <Button variant="contained" onClick={() => { updateImgStatus(); closePopup(); }} color="primary">Update</Button>
                </DialogActions>
              </Grid>
            </div>
          </div>
        </Dialog>
      )}
      {isImagePopupOpen && (
        <Dialog open={true} onClose={() => setIsImagePopupOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            Reference Image Preview
            <IconButton
              onClick={() => setIsImagePopupOpen(false)}
              style={{ position: "absolute", right: 10, top: 10 }}
            >
              <CloseIconColor />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ textAlign: "center" }}>
            <img
              src={selectedImage}
              alt="Selected Reference"
              style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                const link = document.createElement("a");
                link.href = selectedImage;
                link.download = "reference_image.jpg";
                link.click();
              }}
            >
              Download
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

const localStyles = makeStyles((theme: Theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tableText: {
    fontSize: "14px",
    color: "#3C3C3C",
  },
  versionChip: {
    backgroundColor: "#e6edf7",
    color: "#2a7ced",
    height: "20px",
    border: `1px solid #2A7CED`,
  },
  deleteButton: {
    backgroundColor: "#F06A6A",
    color: "white",
    "&:hover": {
      backgroundColor: "#D9534F",
    },
  },
  tableCell: {
    textAlign: "left",
    borderBottomColor: "white",
    borderTopColor: "white",
    backgroundColor: "white",
  },
  tableCellBody: {
    textAlign: "left",
    borderBottomColor: "white",
    borderTopColor: "white",
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 3px 6px #00000029",
  },
  statusListStyle: {
    float: "right",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    padding: "10px",
    marginRight: "0",
  },
  statusBadgeStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
  },
  approvedStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#d4f8d4",
    color: "#9cf79c",
    borderColor: "#9cf79c",
  },
  pendingStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#fde8cd",
    color: "#f8d394",
    borderColor: "#f8d394",
  },
  notApprovedStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#f8d7da",
    color: "#f47c88",
    borderColor: "#f47c88",
  },
  imageBoxes: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  imageBox: {
    textAlign: "center",
    width: "28%",
    backgroundColor: "#eee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    padding: "10px",
  },
  image: {
    width: "120px",
    height: "90px",
    margin: "20px",
  },
  imgText: {
    margin: "20px",
  },
  validityLabel: {
    padding: '5px 10px',
    borderRadius: '12px',
    fontSize: '14px',
    display: 'inline-block',
  },
  valid: {
    backgroundColor: '#BAEBD6',
    color: '#02C170',
    opacity: 0.7,
  },
  invalid: {
    backgroundColor: '#FBE9E8',
    color: '#DB4A42',
  },
}));
